import { inject, Injectable } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { InjectableSuperclass } from '@sama/ng-core';
import { firstValueFrom, take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Point3D } from '../../team-apis/otterdam/answers/shape-typings';
import { PointCloudContentStore } from '../state/point-cloud-content-store';
import { interpolateLocation } from '../utils/point-cloud-interpolation-helper';
import { addPoints, subtractPoints } from '../utils/point-utils';

@Injectable()
export class InspectService extends InjectableSuperclass {
  private store = inject(PointCloudContentStore);

  async inspectFocusedShape() {
    const focusedShape = this.store.getFocusedShapeStore()?.state();
    if (!focusedShape) {
      return;
    }

    const location = interpolateLocation(
      focusedShape.key_locations,
      this.store.state().render.frameNumber,
    );
    if (!location.visibility) {
      return;
    }
    await this.inspectPosition(location.position);
  }

  async inspectPosition(inspectedPosition: Point3D) {
    const { position, target } = await firstValueFrom(
      this.store('camera').$.pipe(filter(isDefined), take(1)),
    );

    const newPosition = addPoints(
      position,
      subtractPoints(inspectedPosition, target),
    );
    this.store('camera').assign({
      position: newPosition,
      target: inspectedPosition,
    });
  }
}
